import { render, staticRenderFns } from "./course-selector.vue?vue&type=template&id=b0f94070&scoped=true"
import script from "./course-selector.vue?vue&type=script&lang=js"
export * from "./course-selector.vue?vue&type=script&lang=js"
import style0 from "./course-selector.vue?vue&type=style&index=0&id=b0f94070&prod&lang=scss"
import style1 from "./course-selector.vue?vue&type=style&index=1&id=b0f94070&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f94070",
  null
  
)

export default component.exports